// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user-account-row {\n  padding: 1rem;\n  background-color: #f5f5f5;\n  border-bottom: 2px solid #eee;\n}\n\n.user-account-row:hover {\n  background-color: #eee;\n}\n\n.user-account-row-edit {\n  padding: 0.5rem;\n}\n\n.user-account-row-edit:hover {\n  background-color: #ccc;\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
